import styled from "styled-components";

import FlexBox from "../../common/FlexBox";
import { Body2, H4 } from "../../common/Headings";

const ScrollableLeft = styled(FlexBox)`
  flex: 1;
  flex-direction: column;
  padding: 1.5rem;
  overflow-y: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const LeftSummarySection = ({ summaryText }) => (
  <ScrollableLeft>
    <FlexBox rowGap="1.5rem" column>
      <FlexBox column rowGap="1rem">
        <H4 bold>What the original structure for the AI summary will include?</H4>
        <Body2>{summaryText}</Body2>
      </FlexBox>
    </FlexBox>
  </ScrollableLeft>
);

export default LeftSummarySection;
